import { SlateNode } from '@all-hands-hq/plex-graphql-schema';
import React, { useMemo } from 'react';
import { createEditor } from 'slate';
import { Slate, withReact } from 'slate-react';

import { Entities, EntitiesContext } from './entities';
import { WrappedSlateEditable } from './internal/editor';

type ReadOnlyProps = {
  value: SlateNode[];
  entities: Entities;
  className?: string;
  // Is this editor displayed in a feed
  hideImages?: boolean;
};

export function ReadOnlyEditor({ value, entities, hideImages, className }: ReadOnlyProps): React.ReactElement {
  const editor = useMemo(() => {
    return withReact(createEditor());
  }, []);
  const onChange = (value: SlateNode[]): void => {
    return undefined;
  };

  return (
    // TODO(https://github.com/all-hands-hq/source/issues/1046): use `Slate<SlateElement>`
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <Slate editor={editor} value={value} onChange={onChange}>
      <EntitiesContext.Provider value={entities}>
        <WrappedSlateEditable className={className} hideImages={hideImages} readOnly />
      </EntitiesContext.Provider>
    </Slate>
  );
}
